import { config } from "../config";

/** API password reset. Off until the hosted build sets VITE_PASSWORD_CHANGE. */
export function passwordChangeEnabled(): boolean {
  return config.passwordChange;
}
